import { render, staticRenderFns } from "./doggy-packs-details-container.vue?vue&type=template&id=b4bc3a38&scoped=true&lang=pug"
import script from "./doggy-packs-details-container.js?vue&type=script&lang=js&external"
export * from "./doggy-packs-details-container.js?vue&type=script&lang=js&external"
import style0 from "./doggy-packs-details-container.vue?vue&type=style&index=0&id=b4bc3a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bc3a38",
  null
  
)

export default component.exports